import { render } from "./SkipperFilter.vue?vue&type=template&id=af2f5560&scoped=true"
import script from "./SkipperFilter.vue?vue&type=script&lang=js"
export * from "./SkipperFilter.vue?vue&type=script&lang=js"

import "./SkipperFilter.vue?vue&type=style&index=0&id=af2f5560&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-af2f5560"

export default script